module.exports = __webpack_public_path__ + "ed9e38e2c402c57b5f30667b4ed3adb2.svg";